export default {
	'set-home-location': 'Set home location',
	'generate-qr-all': 'generate QR for all rows',
	'qr-code': 'QR code',

	'add-passenger': 'Add passenger',
	'edit-passenger': 'Edit passenger'
}